<template>
  <fragment>
    <div class="question-answers-container">
      <slot
          :variables="variables"
          :isSelectAnyInputDisabled="isSelectAnyInputDisabled"
          :onSelectAnyVarChange="onSelectAnyVarChange"
          :isSelectAnyCheckboxDisabledByMaxSelections="isSelectAnyCheckboxDisabledByMaxSelections"
          :isSelectAnyCheckBoxDisabledByExclusive="isSelectAnyCheckBoxDisabledByExclusive"
          :disabledByExclusiveTooltipText="disabledByExclusiveTooltipText"
          :maximumSelections="maximumSelections"
      />
      <template v-if="question.is_select_all_enabled">
        <hr/>
        <span id="variable_wrapper_select_all">
        <b-form-checkbox
            class="v3_control_checkbox question-checkbox"
            :checked="isAllSelected"
            :disabled="isExclusiveChecked"
            @change="$emit('select-all-change', $event)"
        >
          All of the above
        </b-form-checkbox>
      </span>
        <b-tooltip
            v-if="isExclusiveChecked"
            :target="`variable_wrapper_select_all`"
            triggers="click hover"
        >
          {{ disabledByExclusiveTooltipText }}
        </b-tooltip>
      </template>
    </div>
  </fragment>
</template>

<script>
import {QUESTION_TYPES} from '@/store';

export default {
  name: 'SelectAnyWrapper',
  props: {
    preview: Boolean,
    question: Object,
    variables: Array,
  },
  computed: {
    answeredVariables: function () {
      return this.variables.filter((v) => {
        return v.response && parseInt(v.response.value) === 1;
      });
    },
    disabledByExclusiveTooltipText: function () {
      if (!this.exclusiveVariable) return null;
      return `This option cannot be selected when ‘${this.exclusiveVariable.input_label}’ is already selected.`;
    },
    exclusiveVariable: function () {
      if (this.question.type !== QUESTION_TYPES.SELECT_ANY) return null;
      return this.variables.find((v) => v.is_exclusive);
    },
    maximumSelections: function () {
      return this.question.maximum_selections;
    },
    anyNonExclusiveSelected: function () {
      if (this.question.type !== QUESTION_TYPES.SELECT_ANY || this.preview) {
        return false;
      }
      return this.variables.some(
          (variable) =>
              parseInt(variable.response.value) === 1 && !variable.is_exclusive
      );
    },
    isExclusiveChecked: function () {
      return (
          parseInt(((this.exclusiveVariable || {}).response || {}).value) === 1
      );
    },
    isAllSelected: {
      set: function (data) {
        if (this.preview) return;
        this.$emit('select-all-change', data);
      },
      get: function () {
        if (this.preview) return false;
        return this.variables.every((v) => {
          if (v.is_exclusive) return true;
          return !!v.response.value;
        });
      },
    },
  },
  methods: {
    onSelectAnyVarChange: function (value, variable) {
      if (this.preview) {
        return;
      }
      const isVariableExclusive = this.isVariableExclusive(variable);
      if (!value && this.isAllSelected && !isVariableExclusive)
        this.isAllSelected = false;

      this.$nextTick(() => {
        if (this.isSelectAnyCheckBoxDisabledByExclusive(variable)) {
          variable.response.value = null;
        } else if (isVariableExclusive && this.anyNonExclusiveSelected) {
          this.unSelectNonExclusive();
        }
      });
    },
    isSelectAnyCheckboxDisabledByMaxSelections: function (v) {
      if (
          (v.response && parseInt(v.response.value) === 1) ||
          this.question.maximum_selections === 0 ||
          this.isVariableExclusive(v)
      ) {
        return false;
      }
      return this.question.maximum_selections <= this.answeredVariables.length;
    },
    isSelectAnyCheckBoxDisabledByExclusive: function (v) {
      if (!this.exclusiveVariable) return false;
      return (
          this.exclusiveVariable.id !== v.id &&
          parseInt((this.exclusiveVariable.response || {}).value) === 1
      );
    },
    isVariableExclusive: function (variable) {
      return (
          this.exclusiveVariable &&
          parseInt(variable.id) === parseInt(this.exclusiveVariable.id)
      );
    },
    isSelectAnyInputDisabled: function (variable) {
      return (
          this.disableInputs || //if study is submitted
          this.isSelectAnyCheckboxDisabledByMaxSelections(variable) ||
          (!this.isVariableExclusive(variable) &&
              this.isSelectAnyCheckBoxDisabledByExclusive(variable))
      );
    },
    unSelectNonExclusive: function () {
      this.variables.forEach((variable) => {
        if (
            !this.isVariableExclusive(variable) &&
            parseInt(variable.response.value) === 1
        ) {
          variable.response.value = 0;
        }
      });
    },
  },
};
</script>

<style scoped>
.question-answers-container {
  border: 1px solid #AAB0B3;
  padding: 15px;
}
</style>
